<template>
    <div>
        <button class="btn btn_main" data-bs-toggle="modal" data-bs-target="#cancelModal">
            <span>{{ $t("institution.invoicing.cancelSubscription") }}</span>
        </button>
        <div class="modal fade" id="cancelModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
                <div v-if="!subCanceled" class="modal-content modal_wrapper">
                    <div class="modal-header border-0">
                        <h5 class="modal-title title" id="cancelModalLabel">
                            {{ $t("institution.invoicing.cancelingSubscription") }}
                        </h5>
                    </div>
                    <div class="modal-body box">
                        <span>{{ $t('institution.invoicing.reallyCancelSubscription') }}</span>
                    </div>
                    <div class="modal-footer border-0">
                        <button type="button" class="btn btn_secondary" data-bs-dismiss="modal">
                            {{ $t("utils.close") }}
                        </button>
                        <button type="button" class="btn btn_main" @click="cancelSubscription()" style="height: 39px;">
                            {{ $t("institution.invoicing.cancelSubscription") }}
                        </button>
                    </div>
                </div>
                <!-- After cancelling your subscription, you will be able to choose a new plan. -->

                <div v-else class="modal-content modal_wrapper">
                    <div class="modal-header border-0">
                        <h5 class="modal-title title" id="cancelModalLabel">
                            {{ $t("institution.invoicing.settingNewPlan") }}
                        </h5>
                    </div>
                    <div class="modal-body box">
                        <div>
                            <span>{{ $t("institution.invoicing.ifInterestedPickNewPlan") }}:</span>
                        </div>
                        <div class="mt-3">
                            <select class="form-select w-50" v-model="formData.newPlan_id">
                                <option v-for="plan in plans" :key="plan.id">{{ plan.plan }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="modal-footer border-0">
                        <button type="button" class="btn btn_secondary" data-bs-dismiss="modal">
                            {{ $t("utils.close") }}
                        </button>
                        <button type="button" class="btn btn_main" @click="submitNewPlan()" style="height: 39px;">
                            {{ $t("institution.invoicing.setNewPlan") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            subCanceled: false,
            plans: [],
            formData: {
                newPlan_id: null
            }
        }
    },
    props: {
        institutionId: Number
    },
    methods: {
        cancelSubscription() {
            this.$store.getters.api.post(`/institution/${this.institutionId}/subscription/cancel`).then(response => {
                this.subCanceled = true;
                this.loadPlans();
            })
        },
        loadPlans() {
            this.$store.getters.api.get("/plans").then(response => {
                this.plans = response.data.items;
            });
        },
        submitNewPlan() {
            this.$store.getters.api.post(`/institution/${this.institutionId}/subscription/set_plan`, this.formData).then(response => {
                window.location.reload();
            })
        },
    },
}
</script>
<style scoped lang="scss">
@import "@/scss/abstracts/variables";
@import "@/scss/base/typography.scss";

.modal_wrapper {
    padding: 15px 30px 15px 30px;
    border-radius: $radius-xl;

    .modal-body {
        border-radius: $radius-lg;
    }

    .form-select {
        border: 1px solid $black;
    }
}
</style>